import { useEffect, useRef } from 'react';

import { Icon, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { ToolInvocation } from './ToolCallStatus';

interface ConversationStarterSavedProps {
  toolInvocation: ToolInvocation;
  onSaved: () => void;
}

export const ConversationStarterSaved = ({
  toolInvocation,
  onSaved,
}: ConversationStarterSavedProps) => {
  const { t } = useTranslation();
  const isComplete = toolInvocation.state === 'output-available';
  const hasFired = useRef(false);

  useEffect(() => {
    if (isComplete && !hasFired.current) {
      hasFired.current = true;
      onSaved();
    }
  }, [isComplete, onSaved]);

  if (!isComplete) {
    return (
      <Stack
        className="w-fit rounded-full border border-border-insights-subtle bg-bg-insights-subtle px-3 py-1.5"
        inline
        align="center"
        gap={2}
        fullWidth={false}
      >
        <Icon name="Save" className="animate-pulse text-text-insights" />
        <Text size="xs">{t('chat.starters.saving')}</Text>
      </Stack>
    );
  }

  return (
    <Stack
      className="w-fit rounded-full border border-border-positive-subtle bg-bg-positive-subtle px-3 py-1.5"
      inline
      align="center"
      gap={2}
      fullWidth={false}
    >
      <Icon name="CheckCircle2" className="text-text-positive" />
      <Text size="xs" color="secondary">
        {t('chat.starters.saved')}
      </Text>
    </Stack>
  );
};
